var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Plain',{attrs:{"title":"Almost done..."}},[_c('div',{attrs:{"slot":"page_body"},slot:"page_body"},[_c('div',{staticClass:"headline"},[_vm._v("\n      We've sent an email to joe.doe@gmail.com. Open it up to activate your account.\n    ")])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c0bdc22","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PendingRegistration.vue
// module id = null
// module chunks = 